var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndercoreLogoSmall = function SvgAndercoreLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 19 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#andercore-logo-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M7.086-.104c-.025.042-1.35 2.65-2.963 5.814C2.52 8.867.964 11.916.67 12.474l-.523 1.024H3.96L6.7 8.001l2.734-5.49.13.226c.075.125.631 1.224 1.245 2.449l1.105 2.232H8.944l-.761 1.5-.753 1.498h5.983l.753 1.541.76 1.541h3.897l-.737-1.432c-.41-.792-1.98-3.857-3.503-6.814L11.817-.12l-2.35-.025c-1.292-.008-2.365.008-2.381.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F02938",
    d: "M.455 18.5V20h18v-3h-18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "andercore-logo-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M.455 0h18v20h-18z"
  })))));
};
export default SvgAndercoreLogoSmall;